<script setup lang="ts">
import Tooltip from "../Tooltip.vue";
import { useTableDense } from "./density.ts";

withDefaults(defineProps<{ tooltipText?: string }>(), { tooltipText: "" });

const dense = useTableDense();
</script>

<template>
  <td :class="['align-middle [&:has([role=checkbox])]:pr-0', dense ? 'px-1.5 py-2' : 'p-4']">
    <template v-if="tooltipText">
      <Tooltip :text="tooltipText" :follow-cursor="true" class="block h-full w-full">
        <slot />
      </Tooltip>
    </template>
    <template v-else>
      <slot />
    </template>
  </td>
</template>
